import { stringify } from "qs";
import fetchClient from "api/client";
import getPerPageQueryParam from "helpers/getPerPageQueryParam";
import PARTNERS_ENDPOINT from "./partnersEndpoint";

/**
 * @description GET api/partners/list
 * */
export default function getPartnersFilterList({
  queryKey: [, { page, perPage, ...queryParams }],
  signal,
}) {
  const queryString = stringify(
    {
      ...queryParams,
      page: page || 0,
      ...getPerPageQueryParam(perPage),
    },
    { addQueryPrefix: true },
  );

  return fetchClient.get(`${PARTNERS_ENDPOINT}/list${queryString}`, { signal });
}
